import cn from 'classnames';
import styles from './heading.module.scss';

interface IProps {
  onClick: () => void;
  className?: string;
}

const Toggler = ({ onClick, className = '' }: IProps): JSX.Element => {
  return (
    <div className={cn(styles.toggler, className)}>
      <input
        type="checkbox"
        className={styles.toggler__checkbox}
        id="chk"
        {...{ onClick }}
      />
      <label className={styles.label} htmlFor="chk">
        <div className={styles.label__ball}></div>
      </label>
    </div>
  );
};

export default Toggler;
